export const RYANAIR_EVENT = 'ryanair-iframe'

export const RYANAIR_TELEMETRY_TYPE = 'RYANAIR_TELEMETRY'

export const RYANAIR_STATE = {
  CUSTOM_TTL_EXPIRED: 'CUSTOM_TTL_EXPIRED',
  REDIRECT: 'REDIRECT',
  LOADED: 'LOADED',
  SESSION_ERROR: 'SESSION_ERROR',
  TIMEOUT: 'TIMEOUT',
} as const
